const BookSessionModals = ({
  showConfirmationModal,
  showCancelAllModal,
  tutorName,
  userEmail,
  pendingAction,
  onCloseConfirmation,
  onCancelAllExit,
  onCancelAllConfirm,
  onPendingExit,
  onPendingConfirm,
}) => (
  <>
    {showConfirmationModal && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
        <div className="w-full max-w-lg overflow-hidden rounded-xl bg-white shadow-2xl">
          <div className="bg-brand-medium-blue px-6 py-4">
            <h2 className="text-lg font-bold text-white sm:text-xl">
              Request Submitted — Pending Tutor Approval
            </h2>
          </div>
          <div className="px-6 py-5">
            <p className="text-sm text-gray-700 sm:text-base">
              Your booking request has been sent to <strong>{tutorName}</strong> and to{' '}
              <strong>{userEmail}</strong> via email.
            </p>
            <h3 className="mt-5 text-sm font-semibold text-gray-900">What happens next</h3>
            <ol className="mt-2 list-decimal space-y-2 pl-5 text-sm text-gray-600">
              <li>
                No charge yet. Your payment will only be processed after the tutor accepts your
                requested session(s).
              </li>
              <li>Tutor review. The tutor will review your selections and follow up if needed.</li>
            </ol>
            <button
              type="button"
              onClick={onCloseConfirmation}
              className="mt-6 w-full rounded-lg bg-brand-medium-blue px-4 py-3 text-sm font-semibold text-white hover:bg-brand-dark-blue"
            >
              Done
            </button>
          </div>
        </div>
      </div>
    )}

    {showCancelAllModal && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
        <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-2xl">
          <h2 className="text-xl font-bold text-brand-dark-blue">Cancel All Selections?</h2>
          <p className="mt-2 text-sm text-gray-600">
            All of your session selections will be deleted. This action cannot be undone.
          </p>
          <div className="mt-6 flex justify-end gap-3">
            <button
              type="button"
              onClick={onCancelAllExit}
              className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
            >
              Exit
            </button>
            <button
              type="button"
              onClick={onCancelAllConfirm}
              className="rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white hover:bg-red-700"
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    )}

    {pendingAction && (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 px-4">
        <div className="w-full max-w-md rounded-xl bg-white p-6 shadow-2xl">
          <h2 className="text-xl font-bold text-brand-dark-blue">
            {pendingAction.type === 'delete' ? 'Confirm Session Cancellation' : 'Confirm Session Update'}
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            {pendingAction.type === 'delete'
              ? 'Are you sure you want to cancel this session?'
              : 'Are you sure you want to update this session?'}
          </p>
          <div className="mt-6 flex justify-end gap-3">
            <button
              type="button"
              onClick={onPendingExit}
              className="rounded-lg border border-gray-300 px-4 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={onPendingConfirm}
              className={`rounded-lg px-4 py-2 text-sm font-semibold text-white ${
                pendingAction.type === 'delete'
                  ? 'bg-red-600 hover:bg-red-700'
                  : 'bg-brand-medium-blue hover:bg-brand-dark-blue'
              }`}
            >
              Confirm
            </button>
          </div>
        </div>
      </div>
    )}
  </>
);

export default BookSessionModals;
